export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-print-9675d1115756e15299bbf358f7fee87f.svg";